const otherDetails = {
  fields: {
    title: {
      label: 'Title'
    }
  }
}

export default otherDetails
